import { cloneDeep } from 'lodash';

import { ITASCA_SHARED_SELECTIONS_URL } from '@/constants/urls';
import { resolveV3 } from '@/endpoints/resolveV3';

import { AcresFeature } from '../../../../models/features';
import DataResponse from '../../../types';

export interface ISharedResponse {
  id: string;
  source_user: string;
  created_at: string;
  updated_at: string;
  boundary_set: Omit<AcresFeature, 'type'>[];
}

export interface ICorrectedSharedResponse extends ISharedResponse {
  boundary_set: AcresFeature[];
}

/**
 * Takes the response and adds the correct Feature Types (Claim or Saved) to the boundaries
 * @param data Response from /land/saved_selections/
 * @returns
 */
function transformer(
  data: DataResponse<ISharedResponse>
): DataResponse<ICorrectedSharedResponse> {
  const clonedData = cloneDeep(data);

  if (clonedData.res?.data?.boundary_set) {
    const { boundary_set } = clonedData.res.data;
    const newBoundarySet: AcresFeature[] = boundary_set.map((boundary) => ({
      ...boundary,
      type: 'Feature',
    }));

    // Transforms boundary_set to new boundary set
    clonedData.res.data.boundary_set = newBoundarySet;
  }

  return clonedData as DataResponse<ICorrectedSharedResponse>;
}

export async function getSharedSelections(id: string) {
  const data: DataResponse<ISharedResponse> = await resolveV3(
    {
      url: `${ITASCA_SHARED_SELECTIONS_URL}${id}/`,
    },
    {
      baseUrl: 'itasca',
    }
  );

  return transformer(data);
}
